"use client";
import React from "react";
import { EVENT_MAPPING } from "@/contants";
import NoData from "../NoData";
import { useMatchData } from '@/hooks/useMatchData';
import { Image } from '@/lib/target';
import LoadingInner from "@/app/loadingInner";
const homeClass = "flex flex-row-reverse items-center";
const awayClass = "flex items-center";

const displayImageLink = (imageLink) => {
  if (Array.isArray(imageLink) && imageLink.length === 0) {
    return DEFAULT_IMAGE_URL;
  }
  return imageLink || "https://demofree.sirv.com/nope-not-here.jpg";
};

const EventsNote = () => {
    return (
      <div className="bg-header-blue dark:bg-black">
        <div className="text-dark-gray dark:text-stroke-o3 pt-4 pl-3">Chú thích:</div>
        <div className="grid grid-cols-3 @lg:grid-cols-4 gap-4 bg-white-half dark:bg-black py-5 px-3 dark:text-stroke-o3"> 
          {
            Object.values(EVENT_MAPPING).map((event, index) => {
              return (
                <div key={index} className="flex items-center">
                  <Image
                    alt="event-icon"
                    src={displayImageLink(event.iconImgLink)}
                    className="h-5 w-5 mx-2"
                  />
                  <p>{event.name}</p>
                </div>
              )
            })
          }
      </div>
    </div>
    );
  };

const renderEvents = (events) => {
  return events.map((event, index) => {
    const isHomeEvent = event.homeEvent;
    const hasOverTime = event.overTime > 0;
    const eventClass = isHomeEvent ? homeClass : awayClass;
    const playerName = event?.playerName || event?.players?.name
    const playerAssist = event?.assistPlayers?.name || null

    return event && (
      <div
        key={index}
        className="flex flex-row items-center py-2 justify-center text-xs dark:text-stroke-o3"
      >
        {isHomeEvent ? (
          <div className="w-5/12 flex items-center justify-end">
            <div className={eventClass}>
              <Image
                alt="event-icon"
                src={displayImageLink(EVENT_MAPPING[event.type].iconImgLink)}
                className="h-5 w-5 mx-2"
              />
              <div>
                <p>{playerName}</p>
                {playerAssist && <p>({playerAssist})</p>}
              </div>
            </div>
          </div>
        ) : (
          <div className="w-5/12"></div>
        )}

        <div className="text-blur-gray w-1/12 text-center dark:text-stroke-o3 font-semibold">
          {event.minute}'{hasOverTime && `+${event.overTime}`}
        </div>

        {!isHomeEvent ? (
          <div className="w-5/12 flex items-center justify-start">
            <div className={eventClass}>
              <Image
                alt="event-icon"
                src={displayImageLink(EVENT_MAPPING[event.type].iconImgLink)}
                className="h-5 w-5 mx-2"
              />
              <div>
                <p>{playerName}</p>
                {playerAssist && <p>({playerAssist})</p>}
              </div>
            </div>
          </div>
        ) : (
          <div className="w-5/12"></div>
        )}
      </div>
    );
  });
};

const LiveEvents = ({ matchId  }) => {
  const { eventLive, matchLive, loading} = useMatchData(matchId);
  const status = matchLive?.status;
  const isLive = [1,2,3,4,5].includes(status);

  let eventsData = matchLive?.events?.length > 0
      ? matchLive.events
      : [];

  if ([1,2,3,4,5].includes(status)) {
    eventsData = eventLive?.events?.length > 0 ? eventLive.events : eventsData;
  }

  return loading && !isLive ? (<LoadingInner/>) : (eventsData?.length ? (
    <React.Fragment>
      <div className="bg-white dark:bg-black rounded pb-5 pt-2">
        {eventsData?.length > 0 && renderEvents(eventsData)}
      </div>
      <EventsNote />
    </React.Fragment>
  ) : (<NoData message="Không có dữ liệu"/>));
};

export default React.memo(LiveEvents);
